import React from 'react';
import './TopMenuItem.scss';

export interface TopMenuItemProps {
    iconName?: string;
    onClick: any
}
function TopMenuItem(props: any) {
    return (
        <div className='top-menu-ball' onClick={props.onClick}>
            <img className='top-menu-icon' src={process.env.PUBLIC_URL + '/icons/' + props.iconName} />
        </div>
    );
}

export default TopMenuItem;